import Autocomplete from './Autocomplete'

export default Autocomplete



// WEBPACK FOOTER //
// ./src/components/Autocomplete/index.js